import { IActivity } from "@wingspanhq/users/dist/lib/interfaces";
import { BusinessProfile } from "../steps/BusinessProfile";
import { OnboardingContext, OnboardingModuleBusinessProfile } from "../types";
import {
  buildOnboardingStep,
  UseCreateOnboardingStep,
  useOnboardingStepQueryConfig
} from "../components/OnboardingFlowUtils";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryActivities } from "../../../query/users/queries";
import { FlowStep } from "../../../shared/components/FlowSwitch/types";

const getStatus = (activity?: IActivity) => {
  if (activity?.flows.onboardingBusinessProfile?.complete) {
    return "Complete";
  }

  return "None";
};

export const getBusinessProfileStepConfig = (
  _: OnboardingModuleBusinessProfile,
  __: OnboardingContext,
  activity?: IActivity
): FlowStep => {
  const slug = "business-profile";

  const status = getStatus(activity);

  return {
    title: "Business profile",
    slug,
    component: BusinessProfile,

    status,
    result: {
      Complete: {
        title: "Your business profile was saved",
        description:
          "Your business profile was saved and will help contractors identify your business. Click continue for the next step."
      }
    }
  };
};

export const useBusinessProfileStep: UseCreateOnboardingStep<
  OnboardingModuleBusinessProfile
> = modules => {
  const config = useOnboardingStepQueryConfig(modules, "business_profile");
  const userId = useUserId();
  const queryActivity = useQueryActivities(userId, config);

  return (onboardingModule, contextValue) =>
    buildOnboardingStep({
      getConfig: getBusinessProfileStepConfig,
      module: onboardingModule,
      context: contextValue,
      queries: [queryActivity]
    });
};
